module.exports = __webpack_public_path__ + "static/media/health_1.ec20879c.svg";